import { shareColumnsExtend, shareFormColumnsExtend } from './share';
import _ from 'lodash';
export const OPTION_TYPES = [
]

const entityColumns = {
  id: {
    model_name: 'Option',
    column_type: 'id',
  },
  created_at: {
    model_name: 'Option',
    column_type: 'datetime',
  },
  updated_at: {
    model_name: 'Option',
    column_type: 'datetime',
  },
  type: {
    model_name: 'Option',
    column_type: 'type',
    extra: {
      options: [],
    },
  },
  name: {
    model_name: 'Option',
    column_type: 'string',
  },
  position: {
    model_name: 'Option',
    column_type: 'integer',
  },
  prompt: {
    model_name: 'Option',
    column_type: 'string',
  },
  guidance_scale: {
    model_name: 'Option',
    column_type: 'integer',
  },
  negative_prompt: {
    model_name: 'Option',
    column_type: 'string',
  },
  cover: {
    model_name: 'Option',
    column_type: 'attached',
    extra: {
      size: 5,
    },
  },
  creator: {
    model_name: 'Option',
    column_type: 'belongs_to',
    extra: {
      association_name: 'creator',
      model_name: '',
    },
  },
  creator_id: {
    model_name: 'Option',
    column_type: 'belongs_to',
    extra: {
      association_name: 'creator',
      model_name: '',
    },
  },
}

export const columnsExtend = (columns) => {
  return shareColumnsExtend(_.cloneDeep(entityColumns), columns)
}

export const formColumnsExtend = (columns, { formColumnsConfig = {}, type, data }) => {
  return shareFormColumnsExtend(_.cloneDeep(entityColumns), columns, { formColumnsConfig, type, data })
}
